var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchpointLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "-60.4 -60.4 301.9 301.9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lp-tile",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9764E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E28DB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181.137,
    height: 181.137,
    rx: 40.76,
    fill: "url(#lp-tile)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.266 12.299)",
    stroke: "#fff",
    strokeWidth: 14,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.882 58.608 L 15.622 76.678 A 12.6 12.6 0 0 0 15.947 100.648 L 33.198 105.982 A 7 7 0 0 1 37.828 110.635 L 42.984 127.604 A 12.6 12.6 0 0 0 66.987 127.943 L 84.877 74.543 A 12.6 12.6 0 0 0 68.882 58.608 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.53 34.19 A 54.375 54.375 0 0 1 109.345 111.005"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpointLogo);
export default __webpack_public_path__ + "static/media/LaunchpointLogo.5d5c3b68f102ee8cde5f056b7572627a.svg";
export { ForwardRef as ReactComponent };